import { useTranslation } from '@/i18n';
import { getPaymentMethodLabel } from '@/utils/paymentMethodLabel';
import type { ApPayeeDetail } from 'ap-openapi';
import classnames from 'classnames/bind';
import { FC } from 'react';
import styles from './PayeeInfo.module.scss';
import { PayeeInfoRow } from './PayeeInfoRow';

const cx = classnames.bind(styles);

type Props = {
  payeeDetail: ApPayeeDetail;
};

export const PayeeInfo: FC<Props> = ({ payeeDetail }) => {
  const { t } = useTranslation();

  const paymentMethodLabel = getPaymentMethodLabel(
    payeeDetail.payment_method,
    t
  );

  const isBankTransfer = payeeDetail.payment_method === 'bank_transfer';
  const hasAccountDisplayName = !!payeeDetail.account_display_name;
  const accountDisplayName =
    payeeDetail.account_display_name ||
    t('payee_account_display_name_unregistered');

  return (
    <div className={cx(styles['payee-info'])}>
      <PayeeInfoRow
        label={t('payee_payment_method_label')}
        value={paymentMethodLabel}
      />
      {isBankTransfer && (
        <PayeeInfoRow
          label={t('payee_account_display_name')}
          value={accountDisplayName}
          valueClassName={
            !hasAccountDisplayName
              ? styles['payee-info-value-unregistered']
              : undefined
          }
        />
      )}
    </div>
  );
};

PayeeInfo.displayName = 'PayeeInfo';
